<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="ការទូទាត់ប្រាក់សម្រាប់អតិថិជន" name="first" v-if="allow_user('sa|ca|sl')"></el-tab-pane>
			<el-tab-pane label="ការប្រមូលប្រាក់អ្នកដឹកជញ្ជូន" name="second"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកដឹកជញ្ជូន" name="third" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកទៅទទួលកញ្ចប់ឥវ៉ាន់" name="forth" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកទីផ្សារ" name="fifth" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
		</el-tabs>
		<loading v-if="!loaded"/>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.client" type="text" @keyup.enter="searchPayment()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchPayment()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>

			<md-card v-for="(client, index) in clientList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}}. <b>{{client.client_name}}</b> {{client.client_phone}} ({{client.client_note}})</h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row>
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>ប្រភេទ និងទីតាំង</md-table-head>
									<md-table-head>អ្នកទទួល និងចំណាំ</md-table-head>
									<md-table-head>តម្លៃឥវ៉ាន់</md-table-head>
									<md-table-head>ថ្លៃដឹកជញ្ជូន</md-table-head>
									<md-table-head>ស្ថានភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(pkg, index) in client.packageList">
									<md-table-cell>{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
									</md-table-cell>
									<md-table-cell><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</md-table-cell>
									<md-table-cell>{{ pkg.receiver_phone }}<br><span v-if="pkg.status != 'dlv'">{{pkg.note}}</span></md-table-cell>
									<md-table-cell>
										<span v-if="pkg.status == 'dlv'">
											<b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b>
											<br>
											<span v-if="pkg.price == 0">(ទូទាត់រួច)</span>
											<span v-else>(មិនទាន់ទូទាត់)</span>
										</span>
										<span v-else><b>-----</b><br>({{ config.moneylify(pkg.price, pkg.price_currency)
											}})</span>
									</md-table-cell>
									<md-table-cell>
										<span v-if="pkg.status == 'dlv'">
											<b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }} </b>
											<br>
											<span> ({{config.getStatus(pkg.fee_responsible)}})</span>
										</span>
										<span v-else><b>-----</b><br>({{ config.moneylify(pkg.fee, pkg.fee_currency) }})</span>
									</md-table-cell>
									<md-table-cell>
										<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
										<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
										<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
										<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
										<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
									</md-table-cell>
								</md-table-row>
								<md-table-row>
									<!-- <md-table-cell></md-table-cell> -->
									<md-table-cell>​</md-table-cell>
									<md-table-cell></md-table-cell>
									<md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
									<md-table-cell><b>{{config.moneylify(client.total_usd, 'usd')}} +
											{{config.moneylify(client.total_khr, 'khr')}}</b></md-table-cell>
									<md-table-cell><b>{{config.moneylify(client.total_fee_usd, 'usd')}} +
											{{config.moneylify(client.total_fee_khr, 'khr')}}</b></md-table-cell>
									<md-table-cell></md-table-cell>
								</md-table-row>
							</md-table>

						</div>
						<div class="md-layout-item md-size-35 text-right client-center">
							<img :src="config.getProfileUrl(client.client_bank_usd)" class="bank-image" />
							<img :src="config.getProfileUrl(client.client_bank_khr)" class="bank-image"  />
						</div>
						<div class="md-layout-item md-size-35 text-right client-center">
							<b><span>ប្រាក់ត្រូវទូទាត់ឱ្យអតិថិជនសរុប : {{config.moneylify(client.total_usd -
									client.total_fee_usd,
									'usd')}} +
									{{config.moneylify(client.total_khr - client.total_fee_khr, 'khr')}}</span></b>
						</div>
						<!-- <div class="md-layout-item md-size-15 text-right client-center">
							
						</div> -->
							
						<div class="md-layout-item md-size-30 text-right client-center">
							<div style="display: flex; flex-direction: column;">
								<a :href="'#/print_payment/' + client.client_hash_id" target="_blank">
								<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ PDF</md-button>
							</a>
							<download-excel :meta="excel.json_meta" :fetch="() => getClientPayment(client.client_hash_id)" :fields="excel.header" worksheet="កញ្ចប់ឥវ៉ាន់" :name="client.client_hash_id + '-' + client.client_name + '.xls'">
								<md-button class="md-raised md-primary" style="width:100%">ទាញយក EXCEL</md-button>
							</download-excel>
							<md-button class="md-raised md-primary" style="width:100%" @click="showDialog(client)"  v-if="allow_user('sa')">ទូទាត់</md-button>
							</div>
						</div>
					</div>
				</md-card-content>
			</md-card>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>



		<div v-if="tabName == 'second' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.driver" type="text" @keyup.enter="searchPaymentDriver()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchPaymentDriver()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>

			<md-card v-for="(driver, index) in driverList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}}. <b>{{driver.driver_name}}</b> {{driver.driver_phone}}
						({{driver.driver_note}})</h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row>
									<!-- <md-table-head>ល.រ.</md-table-head> -->
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>ប្រភេទ និងទីតាំង</md-table-head>
									<md-table-head>អ្នកទទួល និងចំណាំ</md-table-head>
									<md-table-head>តម្លៃឥវ៉ាន់</md-table-head>
									<md-table-head>ថ្លៃដឹកជញ្ជូន</md-table-head>
									<md-table-head>ស្ថានភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(pkg, index) in driver.packageList">
									<!-- <md-table-cell></md-table-cell> -->
									<md-table-cell>​{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
									</md-table-cell>
									<md-table-cell><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</md-table-cell>
									<md-table-cell>{{ pkg.receiver_phone }}<br><span v-if="pkg.status != 'dlv'">{{pkg.note}}</span></md-table-cell>
									<md-table-cell>
										<span v-if="pkg.status == 'dlv'">
											<b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b>
											<br>
											<span v-if="pkg.price == 0">(ទូទាត់រួច)</span>
											<span v-else>(មិនទាន់ទូទាត់)</span>
										</span>
										<span v-else><b>-----</b><br>({{ config.moneylify(pkg.price, pkg.price_currency)
											}})</span>
									</md-table-cell>
									<md-table-cell>
										<span v-if="pkg.status == 'dlv'">
											<b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }} </b>
											<br>
											<span> ({{config.getStatus(pkg.fee_responsible)}})</span>
										</span>
										<span v-else><b>-----</b><br>({{ config.moneylify(pkg.fee, pkg.fee_currency) }})</span>
									</md-table-cell>
									<md-table-cell>
										<div style="display: flex;flex-direction: row;align-items: center;">
											<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status)}}</span>
											<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
											<span class="neutral" v-if="pkg.status == 'dvr'">{{
												config.getStatus(pkg.status)}}</span>
											<span class="green" v-if="pkg.status == 'dlv'">{{
												config.getStatus(pkg.status)}}</span>
											<span class="return" v-if="pkg.status == 'rtn'">{{
												config.getStatus(pkg.status)}}</span>
											<md-button class="md-just-icon md-simple md-success" @click="pickPackage(pkg.hash_id)"
												v-if="pkg.status == 'wdv'">
												<md-icon>beenhere</md-icon>
												<md-tooltip md-direction="top">កែស្ថានភាពទៅ កំពុងដឹកជញ្ជូន</md-tooltip>
											</md-button>
											<md-button class="md-just-icon md-simple md-success" @click="deliverPackage(pkg.hash_id)"
												v-if="pkg.status == 'dvr'">
												<md-icon>beenhere</md-icon>
												<md-tooltip md-direction="top">កែស្ថានភាពទៅ បានដឹកដល់អតិថិជន</md-tooltip>
											</md-button>
										</div>

									</md-table-cell>
								</md-table-row>
								<md-table-row>

									<md-table-cell>​</md-table-cell>
									<md-table-cell></md-table-cell>
									<md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
									<md-table-cell><b>{{config.moneylify(driver.total_usd, 'usd')}} +
											{{config.moneylify(driver.total_khr, 'khr')}}</b></md-table-cell>
									<md-table-cell><b>{{config.moneylify(driver.total_fee_usd, 'usd')}} +
											{{config.moneylify(driver.total_fee_khr, 'khr')}}</b></md-table-cell>
									<md-table-cell></md-table-cell>
								</md-table-row>
							</md-table>

						</div>
						<div class="md-layout-item md-size-80 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ប្រាក់ត្រូវទូទាត់ឱ្យក្រុមហ៊ុនសរុប : {{config.moneylify(driver.total_usd +
									driver.total_fee_usd,
									'usd')}} +
									{{config.moneylify(driver.total_khr + driver.total_fee_khr, 'khr')}}</span></b>
						</div>

						<div class="md-layout-item md-size-20 text-right" v-if="allow_user('sa|ad|sl')">
							<md-button class="md-raised md-primary" style="width:100%" @click="showDialogDriver(driver)">
								ទូទាត់</md-button>
						</div>

					</div>
				</md-card-content>
			</md-card>

			<h4 class="text-center" v-if="driverList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4>

		</div>

		<div v-if="tabName == 'third' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.driver_fee" type="text" @keyup.enter="searchFeeDriver()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchFeeDriver()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
				<div class="md-layout-item md-size-40 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ទឹកប្រាក់សរុបត្រូវទូទាត់ : {{config.moneylify(0,
									'usd')}} +
									{{config.moneylify(total_fee, 'khr')}}</span></b>
				</div>
				<div class="md-layout-item md-size-10 text-right">
					<a :href="'#/print_payment_driver'" target="_blank">
						<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ</md-button>
					</a>
				</div>
			</div>

			<md-card v-for="(driver, index) in driverFeeList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}}. <b>{{driver.driver_name}}</b> {{driver.driver_phone}}
						({{driver.driver_note}})</h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-size-30 text-left">
							<b><span>ចំនួនកញ្ចប់សរុប : {{driver.total_package}} កញ្ចប់</span></b><br>
							<b><span>ចំនួនកញ្ចប់បានត្រឡប់សរុប : {{driver.total_returned}} កញ្ចប់</span></b><br>
							<b><span>ចំនួនកញ្ចប់បានដឹកដល់អតិថិជនសរុប : {{driver.total_delivered}} កញ្ចប់</span></b><br>

						</div>
						<div class="md-layout-item md-size-50 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ប្រាក់ត្រូវទូទាត់ឱ្យអ្នកដឹកជញ្ជូន : {{config.moneylify(driver.total_payment, 'khr')}}</span></b>
						</div>

						<div class="md-layout-item md-size-20 text-right">
							<md-button class="md-raised md-primary" style="width:100%" @click="showDialogDriverFee(driver)">
								ទូទាត់</md-button>
						</div>
					</div>
				</md-card-content>
			</md-card>

			<h4 class="text-center" v-if="driverFeeList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4>

		</div>
		<div v-if="tabName == 'forth' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.driver_pickup_fee" type="text" @keyup.enter="searchPickupFeeDriver()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchPickupFeeDriver()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
				<div class="md-layout-item md-size-40 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ទឹកប្រាក់សរុបត្រូវទូទាត់ : {{config.moneylify(0,
									'usd')}} +
									{{config.moneylify(total_pickup_fee, 'khr')}}</span></b>
				</div>
				<div class="md-layout-item md-size-10 text-right">
					<a :href="'#/print_payment_driver_pickup'" target="_blank">
						<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ</md-button>
					</a>
				</div>
			</div>

			<md-card v-for="(driver, index) in driverPickupFeeList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}}. <b>{{driver.driver_name}}</b> {{driver.driver_phone}}
						({{driver.driver_note}})</h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-size-30 text-left">
							<b><span>ចំនួនកញ្ចប់សរុប : {{driver.total_package}} កញ្ចប់</span></b><br>
							<b><span>ចំនួនកញ្ចប់បានត្រឡប់សរុប : {{driver.total_returned}} កញ្ចប់</span></b><br>
							<b><span>ចំនួនកញ្ចប់បានដឹកដល់អតិថិជនសរុប : {{driver.total_delivered}} កញ្ចប់</span></b><br>

						</div>
						<div class="md-layout-item md-size-50 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ប្រាក់ត្រូវទូទាត់ឱ្យអ្នកដឹកជញ្ជូន : {{config.moneylify(driver.total_payment, 'khr')}}</span></b>
						</div>

						<div class="md-layout-item md-size-20 text-right">
							<md-button class="md-raised md-primary" style="width:100%" @click="showDialogDriverPickupFee(driver)">
								ទូទាត់</md-button>
						</div>

					</div>
				</md-card-content>
			</md-card>

			<!-- <h4 class="text-center" v-if="driverFeeList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4> -->
		</div>
		<div v-if="tabName == 'fifth' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.referral_fee" type="text" @keyup.enter="searchReferralFee()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchReferralFee()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
				<div class="md-layout-item md-size-40 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ទឹកប្រាក់សរុបត្រូវទូទាត់ : {{config.moneylify(0,
									'usd')}} +
									{{config.moneylify(total_referral_fee, 'khr')}}</span></b>
				</div>
				<div class="md-layout-item md-size-10 text-right">
					<a :href="'#/print_payment_referral'" target="_blank">
						<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ</md-button>
					</a>
				</div>
			</div>

			<md-card v-for="(referral, index) in referralFeeList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}}. <b>{{referral.referral_name}}</b> {{referral.referral_phone}}
						({{referral.referral_note}})</h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-size-30 text-left">
							<b><span>ចំនួនកញ្ចប់សរុប : {{referral.total_package}} កញ្ចប់</span></b><br>
							<b><span>ចំនួនកញ្ចប់បានត្រឡប់សរុប : {{referral.total_returned}} កញ្ចប់</span></b><br>
							<b><span>ចំនួនកញ្ចប់បានដឹកដល់អតិថិជនសរុប : {{referral.total_delivered}} កញ្ចប់</span></b><br>

						</div>
						<div class="md-layout-item md-size-50 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ប្រាក់ត្រូវទូទាត់ឱ្យអ្នកដឹកជញ្ជូន : {{config.moneylify(referral.total_payment, 'khr')}}</span></b>
						</div>

						<div class="md-layout-item md-size-20 text-right">
							<md-button class="md-raised md-primary" style="width:100%" @click="showDialogReferralFee(referral)">
								ទូទាត់</md-button>
						</div>

					</div>
				</md-card-content>
			</md-card>
		</div>

		<md-dialog-confirm :md-active.sync="payDialogActive" md-title="តើអ្នកពិតជាចង់ទូទាត់សម្រាប់អតិថិជននេះមែនទេ ?"
			md-confirm-text="ទូទាត់" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="payClient" />
		<md-dialog-confirm :md-active.sync="driverDialogActive"
			md-title="តើអ្នកពិតជាទូទាត់ប្រាក់ជាមួយអ្នកដឹកជញ្ជូននេះមែនទេ ?" md-confirm-text="ទូទាត់" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="payDriver" />
		<md-dialog-confirm :md-active.sync="driverFeeDialogActive"
			md-title="តើអ្នកពិតជាចង់បើកប្រាក់ឲ្យអ្នកដឹកជញ្ជូននេះមែនទេ ?" md-confirm-text="ទូទាត់" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="payDriverFee" />
		
		<md-dialog-confirm :md-active.sync="pickDialogActive"
			md-title="តើអ្នកពិតជាចង់កែប្រែស្ថានភាពកញ្ចប់ឥវ៉ាន់នេះមែនទេ ?" md-confirm-text="កែប្រែ" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="pickPackage" />
		<md-dialog-confirm :md-active.sync="deliverDialogActive"
			md-title="តើអ្នកពិតជាចង់កែប្រែស្ថានភាពកញ្ចប់ឥវ៉ាន់នេះមែនទេ ?" md-confirm-text="កែប្រែ" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="deliverPackage" />

		<md-dialog-confirm :md-active.sync="driverPickupFeeDialogActive"
			md-title="តើអ្នកពិតជាចង់បើកប្រាក់ឲ្យអ្នកដឹកជញ្ជូននេះមែនទេ ?" md-confirm-text="កែប្រែ" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="payDriverPickupFee" />
			<md-dialog-confirm :md-active.sync="referralFeeDialogActive"
			md-title="តើអ្នកពិតជាចង់បើកប្រាក់ឲ្យអ្នកទីផ្សារនេះមែនទេ ?" md-confirm-text="កែប្រែ" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="payReferralFee" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			// this.searchPayment();
			// this.searchPaymentDriver();
			// this.searchFeeDriver();
			// this.searchPickupFeeDriver();
			// this.searchReferralFee();
		},
		watch: {
			"tabName": function() {
				this.loaded = false;
				if(this.tabName == "first") { this.searchPayment(); }
				if(this.tabName == "second") { this.searchPaymentDriver(); }
				if(this.tabName == "third") { this.searchFeeDriver(); }
				if(this.tabName == "forth") { this.searchPickupFeeDriver(); }
				if(this.tabName == "fifth") { this.searchReferralFee(); }
			}
		},
		mounted() {
			if (this.$store.state.authentication.account_type == 'da') {
				this.tabName = "second";
				this.searchPaymentDriver();
			} else if (this.$store.state.authentication.account_type == 'ad') {
				this.tabName = "second";
				this.searchPaymentDriver();
			} else {
				this.tabName = "first";
				this.searchPayment();
			}
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				payDialogActive: false,
				paySelected: null,
				driverDialogActive: false,
				driverSelected: null,
				driverFeeDialogActive: false,
				driverFeeSelected: null,
				pickDialogActive: false,
				pickSelected: null,
				deliverDialogActive: false,
				deliverSelected: null,
				driverPickupFeeDialogActive: false,
				driverPickupFeeSelected: null,
				referralFeeDialogActive: false,
				referralFeeSelected: null,
				total_fee: 0,
				total_pickup_fee: 0,
				total_referral_fee: 0,
				search: {
					client: "",
					driver: "",
					driver_fee: "",
					driver_pickup_fee: "",
					referral_fee: ""
				},
				client: {
					name: "",
					phone: "",
					description: ""
				},
				loadMore: true,
				clientList: [],
				driverList: [],
				driverFeeList: [],
				driverPickupFeeList: [],
				referralFeeList: [],
				excel: {
					header: {
						'លេខកូដ (Tracking)': 'tracking',
						'កាលបរិច្ឆេទទទួលកញ្ចប់ (Date)': 'created_date',
						'ទីតាំង (Location)': 'location',
						'លេខទូរស័ព្ទអ្នកទទួល (Phone)': 'receiver_phone',
						'តម្លៃកញ្ចប់ឥវ៉ាន់ (Price)': 'price',
						'ថ្លៃដឹកជញ្ជូន (Fee)': 'fee',
						'អ្នកបង់ថ្លៃសេវា (Payer)': 'fee_responsible',
						'ស្ថានភាព (Status)': 'status',
						'ចំណាំ (Note)': 'note'

					},
					json_meta: [
						[
							{
								'key': 'charset',
								'value': 'utf-8'
							}
						]
					]
				}
			}
		},
		methods: {
			searchPayment() {
				this.$http.post(this.config.api + "/admin/client/get/payment", {
					text: this.search.client
				}).then(data => {
					if (data.body.status == 'success') {
						// this.clientList = data.body.data.slice(0, 300);
						this.clientList = data.body.data;
						this.loaded = true;
					}
				})
			},
			searchPaymentDriver() {
				this.$http.post(this.config.api + "/admin/driver/get/payment", {
					text: this.search.driver
				}).then(data => {
					if (data.body.status == 'success') {
						this.driverList = data.body.data
						this.loaded = true;
					}
				})
			},
			searchFeeDriver() {
				this.$http.post(this.config.api + "/admin/driver/get/fee", {
					text: this.search.driver_fee
				}).then(data => {
					if (data.body.status == 'success') {
						this.driverFeeList = data.body.data
						this.loaded = true;
					}
				})
				this.$http.get(this.config.api + "/admin/driver/get/total_fee").then(data => {
					if (data.body.status == 'success') {
						this.total_fee = data.body.data.total_fee
					}
				})
			},
			searchPickupFeeDriver() {
				this.$http.post(this.config.api + "/admin/driver/get/pickup_fee", {
					text: this.search.driver_pickup_fee
				}).then(data => {
					if (data.body.status == 'success') {
						this.driverPickupFeeList = data.body.data
						this.loaded = true;
					}
				})
				this.$http.get(this.config.api + "/admin/driver/get/total_pickup_fee").then(data => {
					if (data.body.status == 'success') {
						this.total_pickup_fee = data.body.data.total_pickup_fee
					}
				})
			},
			searchReferralFee() {
				this.$http.post(this.config.api + "/admin/referral/get_referral_fee", {
					text: this.search.referral_fee
				}).then(data => {
					if (data.body.status == 'success') {
						this.referralFeeList = data.body.data
						this.loaded = true;
					}
				})
				this.$http.get(this.config.api + "/admin/referral/get/total_referral_fee").then(data => {
					if (data.body.status == 'success') {
						this.total_referral_fee = data.body.data.total_referral_fee
					}
				})
			},
			async getClientPayment(hash_id) {
				let data = await this.$http.post(this.config.api + "/admin/client/get/payment", { text: hash_id });
				
				
				if (data.body.status != 'success' || data.body.data.length === 0 || data.body.data[0].packageList.length === 0)  return [];
				
				let client = data.body.data[0];
				let package_list = client.packageList;


				let delivered = [];
				let delivering = [];
				let waiting = [];
				let returned = [];
				let other = [];

				for(let i = 0; i < package_list.length; i++) {
					switch (package_list[i].status) {
						case "dlv":
							delivered.push(package_list[i]);
							break;
						case "dvr":
							delivering.push(package_list[i]);
							break;
						case "rtn":
							returned.push(package_list[i]);
							break;
						case "wdv":
							waiting.push(package_list[i]);
							break;
						default:
						case "wdv":
							other.push(package_list[i]);
							break;
					}
				}
				package_list = [];
				package_list = package_list.concat(delivered, delivering, waiting, other, returned);

				for(let i = 0; i < package_list.length; i++) {
					package_list[i].status = this.config.getStatus(package_list[i].status)
					package_list[i].receiver_phone = String(package_list[i].receiver_phone)
					package_list[i].created_date = this.config.datelify(package_list[i].created_date)
					package_list[i].price = this.config.moneylify(package_list[i].price, package_list[i].price_currency)
					package_list[i].fee = this.config.moneylify(package_list[i].fee, package_list[i].fee_currency)
					package_list[i].fee_responsible = this.config.getStatus(package_list[i].fee_responsible) + "អ្នកបង់"
				}
				package_list.push({ tracking: "" });
				package_list.push({ receiver_phone: "សរុប USD", price: this.config.moneylify(client.total_usd, "usd"), fee: this.config.moneylify(client.total_fee_usd, "usd") });
				package_list.push({ receiver_phone: "សរុប KHR", price: this.config.moneylify(client.total_khr, "khr"), fee: this.config.moneylify(client.total_fee_khr, "khr") });
				package_list.push({ receiver_phone: "ប្រាក់ត្រូវទូទាត់ឱ្យអតិថិជន ($ + ៛)", price: this.config.moneylify(client.total_usd - client.total_fee_usd, "usd"), fee: this.config.moneylify(client.total_khr - client.total_fee_khr, "khr") });
				console.log(package_list);
				return package_list;
			},
			payClient() {
				this.$http.post(this.config.api + "/admin/client/pay", {
					client: this.paySelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់ជូនអតិថិជនបានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.client = "";
						this.searchPayment();
					}

				})
			},
			payDriver() {
				this.$http.post(this.config.api + "/admin/driver/pay", {
					driver: this.driverSelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់ជូនអតិថិជនបានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.driver = "";
						this.searchPaymentDriver();
					}
				})
			},
			payDriverFee() {
				this.$http.post(this.config.api + "/admin/driver/pay_fee", {
					driver: this.driverFeeSelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់ជូនអតិថិជនបានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.driver_fee = "";
						this.searchFeeDriver();
					}

				})
			},
			payDriverPickupFee() {
				this.$http.post(this.config.api + "/admin/driver/pay_pickup_fee", {
					driver: this.driverPickupFeeSelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់ជូនអតិថិជនបានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.driver_pickup_fee = "";
						this.searchPickupFeeDriver();
					}

				})
			},
			payReferralFee() {
				this.$http.post(this.config.api + "/admin/referral/pay_referral_fee", {
					referral: this.referralFeeSelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់ជូនអ្នកទីផ្សារបានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.referral_fee = "";
						this.searchReferralFee();
					}

				})
			},
			pickPackage(hash_id = null) {
				if (hash_id == null & String(this.pickSelected).length > 0) {
					this.$http.post(this.config.api + "/admin/package/pick", {
						hash_id: this.pickSelected
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់បានកែប្រែជោគជ័យ។",
								icon: 'done',
								type: 'success'
							});
							this.searchPaymentDriver();
						}
					})
				} else {
					this.pickSelected = hash_id
					this.pickDialogActive = true
				}
			},
			deliverPackage(hash_id = null) {
				if (hash_id == null & String(this.deliverSelected).length > 0) {
					this.$http.post(this.config.api + "/admin/package/deliver", {
						hash_id: this.deliverSelected
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់បានកែប្រែជោគជ័យ។",
								icon: 'done',
								type: 'success'
							});
							this.searchPaymentDriver();
						}
					})
				} else {
					this.deliverSelected = hash_id
					this.deliverDialogActive = true
				}
			},
			showDialog(client) {
				this.paySelected = client;
				this.payDialogActive = true;
			},
			showDialogDriver(driver) {
				this.driverSelected = driver;
				this.driverDialogActive = true;
			},
			showDialogDriverFee(driver) {
				this.driverFeeSelected = driver;
				this.driverFeeDialogActive = true;
			},
			showDialogDriverPickupFee(driver) {
				this.driverPickupFeeSelected = driver;
				this.driverPickupFeeDialogActive = true;
			},
			showDialogReferralFee(referral) {
				this.referralFeeSelected = referral;
				this.referralFeeDialogActive = true;
			},
			onCancel() {
				this.paySelected = null;
				this.payDialogActive = false;
				this.driverSelected = null;
				this.driverDialogActive = false;
				this.driverPickupFeeDialogActive = false;
				this.driverPickupFeeSelected = null;
				this.referralFeeDialogActive = false;
				this.referralFeeSelected = null;
				this.driverFeeDialogActive = false;
				this.driverFeeSelected = null;
			}
		}
	}
</script>
<style scoped>
	.payment-table {
		width: 100%;

	}
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}
	.bank-image {
		margin-right: 10%;
		width: 40%;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
	.client-center {
		display: flex;
		justify-content: right;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Payments/View.vue